export const fieldName = {
    coverageTerritory: "coverageTerritory",
    vehicleType: "vehicle-vehicleType",
    duration: "duration",
    startDate: "startDate",
    vehicleOwnerPartyType: "vehicle-ownerPartyType",
    vehicleOwnerBirthYear: "vehicle-ownerBirthYear",
    vehicleTotalWeight: "vehicle-totalWeight",
};
